'use client';

import { useIsFetching } from '@tanstack/react-query';
import { useLoaderStore } from '~/components/PartnerLoader/PartnerLoader';
import { tripRepriceKey } from '~/utils/tpv2/tripReprice';
import { useTripId } from './useTripId';

export const useIsTripUpdating = () => {
  const tripId = useTripId();
  const isLoaderActive = useLoaderStore((s) => s.isActive);
  const isRepricing = useIsFetching(tripRepriceKey(tripId)) > 0;

  return isLoaderActive || isRepricing;
};
